import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { signIn, setEncryptedPrivateKey } from "../../../store/reducers/keys";
import "./index.css";
import { LocalStorageKeys } from "../../../utils/strings.utils";
import { saveState } from "../../../utils/localStorage.utils";
import { useWeb3Auth } from "../../../hooks/useWeb3Auth";

const SignIn = () => {
  const { t } = useTranslation();
  const [pin, setNewPin] = useState("");
  const [pinError, setPinError] = useState("");
  const dispatch = useDispatch();
  const { address } = useWeb3Auth();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      if (pin) {
        onSubmit();
      }
    }
  };

  const onSubmit = () => {
    //TODO : Attempt decrypting private key
    try {
      dispatch(signIn(pin));
    } catch (_) {
      setPinError(t("PIN_Signin_Invalid"));
    }
  };

  return (
    <div data-testid="signin-dm-indicator">
      <h1 className="signin-title">{t("PIN_Signin")}</h1>
      <TextField
        id="pin"
        error={!!pinError}
        helperText={pinError}
        label={t("Placeholder_PIN")}
        variant="standard"
        className="SignupPage-input"
        value={pin}
        onChange={(e) => {
          setNewPin(e.target.value);
        }}
        type="password"
        onKeyDown={handleKeyDown}
      />
      <div className="signin-button-group">
        <button
          className="signin-button-forgot"
          onClick={async () => {
            saveState(LocalStorageKeys.PRIVATE_KEY, undefined);
            dispatch(
              setEncryptedPrivateKey({
                encryptedPrivateKey: undefined,
                currentAddress: address,
              })
            );
          }}
        >
          {t("PIN_Signin_Forgot")}
        </button>
        <button className="signin-button-go" onClick={onSubmit}>
          {t("PIN_Signin_Proceed")}
        </button>
      </div>
    </div>
  );
};

export default SignIn;
